"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Budget1ToJSON = exports.Budget1FromJSONTyped = exports.Budget1FromJSON = exports.instanceOfBudget1 = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Budget1 interface.
 */
function instanceOfBudget1(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBudget1 = instanceOfBudget1;
function Budget1FromJSON(json) {
    return Budget1FromJSONTyped(json, false);
}
exports.Budget1FromJSON = Budget1FromJSON;
function Budget1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'microAmount': !(0, runtime_1.exists)(json, 'micro_amount') ? undefined : json['micro_amount'],
        'currency': !(0, runtime_1.exists)(json, 'currency') ? undefined : json['currency'],
    };
}
exports.Budget1FromJSONTyped = Budget1FromJSONTyped;
function Budget1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'micro_amount': value.microAmount,
        'currency': value.currency,
    };
}
exports.Budget1ToJSON = Budget1ToJSON;
